import { render } from "./NumberValidate.vue?vue&type=template&id=79033530"
import script from "./NumberValidate.vue?vue&type=script&lang=js"
export * from "./NumberValidate.vue?vue&type=script&lang=js"
script.render = render

export default script